import { useState, useEffect } from 'react';
import {
  DEFAULT_THEME,
  loadTheme,
  saveTheme,
  applyTheme,
  deriveAccentStrong,
  normalizeHex } from
'../utils/theme';

export const useTheme = () => {
  const [theme, setTheme] = useState(DEFAULT_THEME);
  const [themeDraft, setThemeDraft] = useState(DEFAULT_THEME);

  useEffect(() => {
    const t = loadTheme();
    setTheme(t);
    setThemeDraft(t);
    applyTheme(t);
  }, []);

  const handleThemeChange = (key, value) => {
    setThemeDraft((prev) => ({ ...prev, [key]: value }));
  };

  const handleThemeCommit = (key, value) => {
    const normalized = normalizeHex(value);
    if (!normalized) {
      setThemeDraft((prev) => ({ ...prev, [key]: theme[key] }));
      return;
    }
    const next = { ...theme, [key]: normalized };
    if (key === 'accent') {
      next.accentStrong = deriveAccentStrong(normalized);
    }
    setTheme(next);
    setThemeDraft((prev) => ({ ...prev, [key]: normalized }));
    saveTheme(next);
    applyTheme(next);
  };

  const handleThemeReset = () => {
    setTheme(DEFAULT_THEME);
    setThemeDraft(DEFAULT_THEME);
    saveTheme(DEFAULT_THEME);
    applyTheme(DEFAULT_THEME);
  };

  return {
    theme,
    themeDraft,
    handleThemeChange,
    handleThemeCommit,
    handleThemeReset
  };
};